// extracted by mini-css-extract-plugin
export default {"author":"Author_author__aYyF8","title":"Author_title__uNlho","avatar":"Author_avatar__qtaZZ","online":"Author_online__YwaRu","location":"Author_location__KPNzg"};